import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import BlockChainContent from "../../components/Blockchain/blockchain";
import BlockContentTwo from "../../components/Blockchain/blockchaintwo";

const Blockchain = (props) => {
  return (
    <Fragment>
      <div className="index_ico page_wrapper">
        <Header />
        <main className="page_content">
          <PageTitle pageTitle={"How to send your unique Product code to TopCoin UK"} pagesub={"Home"} />
          <BlockChainContent/>
          <BlockContentTwo />
        </main>
        <Footer />
        <Scrollbar />
      </div>
    </Fragment>
  );
};
export default Blockchain;
